import { cmpMinor, fromMinor, toMinor } from "@linkhr/accounting-domain";
import { currencyDecimals, normalizeDigits } from "@linkhr/i18n/format";

/**
 * Typed text → a decimal string at the currency's scale (`"١٢٥٫٥"` → `"125.500"`
 * in JOD), or null when it is not an amount: more decimals than the currency
 * has, anything but a plain decimal, or a negative where none is allowed.
 * Arabic-Indic digits and the Arabic decimal separator are folded first.
 * Thousands separators (`,` or the Arabic `٬`) must group by three ("1,218"),
 * so a slip like "1,2,3" is refused rather than read as 123.
 */
const GROUPED = /^-?\d{1,3}(,\d{3})+(\.\d+)?$/;

export function parseMoney(text: string, currency: string, allowNegative = false): string | null {
  // `٬` becomes "," first: normalizeDigits drops it, which would hide bad grouping.
  const folded = normalizeDigits(text.replace(/٬/g, ",")).trim();
  if (folded.includes(",") && !GROUPED.test(folded)) return null;
  const plain = folded.replace(/,/g, "");
  if (plain === "") return null;
  const scale = currencyDecimals(currency);
  try {
    const value = fromMinor(toMinor(plain, scale), scale);
    return !allowNegative && cmpMinor(value, "0", scale) < 0 ? null : value;
  } catch {
    return null;
  }
}
